'use client';

import { useTranslations } from 'next-intl';
import { TwitterIcon, FacebookIcon, LinkedInIcon } from '../icons';
import styles from './Blog.module.css';

interface BlogShareButtonsProps {
  title: string;
  slug: string;
}

export function BlogShareButtons({ title, slug }: BlogShareButtonsProps) {
  const t = useTranslations('blog');

  const handleShare = (platform: string) => {
    const shareUrl = typeof window !== 'undefined' ? window.location.href : `${process.env.NEXT_PUBLIC_FE_URL}/blog/${slug}`;
    const encoded = encodeURIComponent(shareUrl);
    let url = '';

    switch (platform) {
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encoded}&text=${encodeURIComponent(title)}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encoded}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/feed/?shareActive=true&text=${encoded}`;
        break;
      default:
        return;
    }
    if (typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className={styles.shareContainer}>
      <span className={styles.shareLabel}>
        {t('share.article')}
      </span>
      <div className={styles.shareButtons}>
        <button className={`${styles.shareButton} ${styles.shareButtonTwitter}`} onClick={() => handleShare('twitter')}>
          <TwitterIcon fontSize="small" />
        </button>
        <button className={`${styles.shareButton} ${styles.shareButtonFacebook}`} onClick={() => handleShare('facebook')}>
          <FacebookIcon fontSize="small" />
        </button>
        <button className={`${styles.shareButton} ${styles.shareButtonLinkedin}`} onClick={() => handleShare('linkedin')}>
          <LinkedInIcon fontSize="small" />
        </button>
      </div>
    </div>
  );
}
